
import { Component, Prop, Vue } from "vue-property-decorator";
import { EventBus } from "@/event-bus";
import { IPageResponse, IUserRequest } from "@/services";
import { Getter } from "vuex-class";
import { ICountry, IUser } from "@/entities";
import IconFilter from "@/components/common/icon/IconFilter.vue";
import { Locale } from "@/store";
import Multiselect from "vue-multiselect";
import VueMethods from "@/vue-methods";
import { ValidationObserver, ValidationProvider } from "vee-validate";

@Component({
  components: {
    IconFilter,
    Multiselect,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [VueMethods],
})
export default class FilterUsers extends Vue {
  @Prop({ required: false, default: null }) params!: IUserRequest;
  @Getter("getLocale") locale!: Locale;
  @Getter("getLoggedUser") loggedUser: IUser | undefined;
  @Getter("getCountriesPage") countriesPage: IPageResponse<ICountry> | undefined;
  private paramsEdit: IUserRequest = Object.assign({}, this.params);
  private visible = false;
  private visibleCountry = true;
  userTypeOptions = ["CLIENTE", "PROSEGUR"];

  get countrySelected(): ICountry | undefined {
    return this.optionsCountries?.find((option) => option.id === this.paramsEdit.countryId);
  }

  set countrySelected(value: ICountry | undefined) {
    this.paramsEdit.countryId = value?.id;
  }

  get optionsCountries(): ICountry[] {
    if (this.loggedUser?.admin) {
      this.visibleCountry = true;
      if (this.loggedUser?.userType == "CLIENTE") {
        return (
          this.countriesPage?.content.filter(
            (country) => this.loggedUser?.country?.id === country.id
          ) || []
        );
      }
      return this.countriesPage?.content || [];
    } else if (this.loggedUser?.country?.id) {
      this.visibleCountry = false;
      this.paramsEdit.countryId = undefined;

      return (
        this.countriesPage?.content.filter(
          (country) => this.loggedUser?.country?.id === country.id
        ) || []
      );
    }
    return [];
  }

  get filterLength(): number {
    let length = 0;
    Object.entries(this.params).forEach(([key, value]) => {
      if (
        value &&
        key !== "active" &&
        key !== "direction" &&
        key !== "orderBy" &&
        key !== "page" &&
        key !== "size"
      ) {
        length++;
      }
    });
    return length;
  }

  doCleanUp(): void {
    Object.keys(this.paramsEdit).forEach((key) => {
      (this.paramsEdit as any)[key] = undefined;
    });

    this.$emit("update:params", Object.assign({}, this.paramsEdit));
    EventBus.$emit("update-users-table");
  }

  doFilter(): void {
    if (!this.paramsEdit.admin) this.paramsEdit.admin = undefined;
    this.$emit("update:params", Object.assign({}, this.cleanUpEmptyStrings(this.paramsEdit)));
    EventBus.$emit("update-users-table");
    this.visible = false;
  }
}
